"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateModelFactory = exports.default = stateModelFactory;
exports.configSchema = void 0;

var _mobxStateTree = require("mobx-state-tree");

var _configuration = require("../configuration");

var _mst = require("../util/types/mst");

var configSchema = (0, _configuration.ConfigurationSchema)('BaseFeatureWidget', {});
exports.configSchema = configSchema;

function stateModelFactory(pluginManager) {
  return _mobxStateTree.types.model('BaseFeatureWidget', {
    id: _mst.ElementId,
    type: _mobxStateTree.types.literal('BaseFeatureWidget'),
    featureData: _mobxStateTree.types.frozen(),
    view: _mobxStateTree.types.safeReference(pluginManager.pluggableMstType('view', 'stateModel'))
  }).actions(function (self) {
    return {
      setFeatureData: function setFeatureData(data) {
        self.featureData = data;
      },
      clearFeatureData: function clearFeatureData() {
        self.featureData = undefined;
      }
    };
  });
}